import styled from "styled-components";
import { ButtonGroup } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const TopBarStyledButtonGroup = styled(ButtonGroup)`
    && {
        border: solid 1px ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
        border-radius: 5px;
    }
`;
